import { render, staticRenderFns } from "./star_ratings.vue?vue&type=template&id=1517bd08&"
import script from "./star_ratings.vue?vue&type=script&lang=js&"
export * from "./star_ratings.vue?vue&type=script&lang=js&"
import style0 from "./star_ratings.vue?vue&type=style&index=0&id=1517bd08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports